module.exports = __webpack_public_path__ + "b19802fbc7b5fbc4753af98191a44768.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/188.png
// module id = 1771
// module chunks = 2